import { Box } from "@mui/system";
import { grey } from "@mui/material/colors";

export default function Layout({ children, padding }: { children: React.ReactNode, padding?: boolean }) {
  return (
    <Box
      sx={{
        height: "100%",
        background: grey[100],
        overflow: "auto",
        p: padding ? 3 : 0,
      }}
    >
      {children}
    </Box>
  );
}
